





































import { defineComponent, ref, PropType, onMounted, onBeforeUnmount } from '@vue/composition-api';
import OlbButton from '../button/button.vue';
import OlbIcon from '../icon/icon.vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useActions, useState } = createNamespacedHelpers('googleStore');
import Vue from 'vue';
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

export interface YouTubePlayerVars {
	rel: string;
	start: number;
	end: number;
	autoplay: number;
	loop: number;
	fs: number;
}

export default defineComponent({
	props: {
		youtubeId: {
			type: String,
		},
		youtubePlayerVars: {
			type: Object as PropType<YouTubePlayerVars>,
		},
		type: {
			type: String as PropType<'mp4' | 'webm'>,
		},
		src: {
			type: String,
		},
		videoCaption: {
			type: String,
		},
	},
	components: {
		OlbButton,
		OlbIcon,
	},
	setup(props, { emit }) {
		const { addVideo, loadYoutubeAPI, loadVideo } = useActions(['addVideo', 'loadYoutubeAPI', 'loadVideo']);
		const { youtube } = useState(['youtube']);
		const isOpen = ref(false);
		const hasConsent = ref(false);

		function stopYouTubeVideo() {
			if (!props.youtubeId) {
				return;
			}
			youtube.value.videos.find((video: any) => {
				if (video.videoId === props.youtubeId) {
					video.player?.stopVideo();
				}
			});
		}

		function isYouTubeConsentGiven() {
			if (typeof (window as any).IsYouTubeConsentAvailable === 'function') {
				return (window as any).IsYouTubeConsentAvailable();
			}
			return false;
		}

		function toggleDialog(event: Event) {
			event.preventDefault();
			isOpen.value = !isOpen.value;
			hasConsent.value = isYouTubeConsentGiven();
			if (!hasConsent.value) {
				// show no-consent dialog and return
				return;
			}
			if (isOpen.value) {
				props.youtubeId && loadVideo(props.youtubeId);
			} else {
				emit('close');
				stopYouTubeVideo();
			}
		}

		function openUserCentrics() {
			if (typeof (window as any).ShowYouTubeConsent === 'function') {
				return (window as any).ShowYouTubeConsent();
			}
		}

		const consentListener = () => {
			hasConsent.value = true;
			loadYoutubeAPI();
			if (props.youtubeId) {
				addVideo({ videoId: props.youtubeId, playerVars: props.youtubePlayerVars });
			}
		};

		onMounted(() => {
			window.addEventListener('YouTubeConsentAvailable', consentListener);
		});

		onBeforeUnmount(() => {
			window.removeEventListener('YouTubeConsentAvailable', consentListener);
		});

		return { isOpen, hasConsent, toggleDialog, openUserCentrics };
	},
});
